module.exports = __webpack_public_path__ + "static/media/chicargos-business-card.ea220f98.jpeg";